module.exports = "<div class=\"modal-content\">\r\n  <div class=\"modal-header\">\r\n    <h4>{{title || 'Confirm'}}</h4>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <p>{{message || 'Are you sure?'}}</p>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-outline-danger\" (click)=\"cancel()\">Cancel</button>\r\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"confirm()\">OK</button>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/confirm/confirm.component.html
// module id = ./src/app/components/confirm/confirm.component.html
// module chunks = main